import { tv } from '@workspace/lib';

export const featuredBannerVariants = tv({
  slots: {
    container: 'px-md md:px-4xl',
    grid: 'md:grid-cols-2',
    contentWrapper: 'text-left',
    contentInner: 'gap-xs',
    heading: 'font-normal text-neutral-500',
    description: 'font-light text-neutral',
    buttonGroup: 'md:pt-xs gap-xs md:gap-sm md:mt-0',
    button: 'w-full xs:w-auto',
    mediaWrapper: 'rounded-2xl',
  },
  variants: {
    style: {
      full: {
        container: 'p-0 md:p-0',
        grid: 'gap-0',
        contentWrapper: 'px-md py-xl md:px-20 md:py-0',
        contentInner: 'md:max-w-128.75 gap-sm',
        mediaWrapper: 'aspect-4/3 self-stretch rounded-none md:aspect-auto md:min-h-180',
      },
      medium: {
        container: 'py-lg md:py-3xl',
        grid: 'md:justify-between',
        mediaWrapper: 'aspect-4/3 md:aspect-[16/11]',
      },
      slim: {
        container: 'py-lg md:py-2xl',
        mediaWrapper: 'aspect-video md:aspect-[2/1]',
      },
    },
    blockAlignment: {
      left: {
        contentWrapper: 'items-start',
        buttonGroup: 'justify-start',
      },
      center: {
        contentWrapper: 'items-center text-center',
        buttonGroup: 'justify-center',
      },
      right: {
        contentWrapper: 'items-end text-right',
        buttonGroup: 'justify-end',
      },
    },
    contentPosition: {
      left: {
        contentWrapper: 'md:order-1',
        mediaWrapper: 'md:order-2',
      },
      right: {
        contentWrapper: 'md:order-2',
        mediaWrapper: 'md:order-1',
      },
    },
  },
  defaultVariants: {
    style: 'medium',
    blockAlignment: 'left',
    contentPosition: 'left',
  },
});
